export default (pageName) =>
  __SERVER__ ? Buffer.from(pageName).toString('base64') : btoa(pageName);
